// Phase A.1 — Preview Mode Notice
// Subtle inline hint rendered at the top of each RSVP variant when
// `settings.disableRsvpSubmit === true` (review/demo/template-preview
// surfaces). Non-blocking, theme-neutral amber pill. The actual submit
// guard + inline error remain the safety fallback in case a user still
// taps Submit.

import React from 'react';
import { Eye } from 'lucide-react';

export default function PreviewModeNotice({ visible }) {
  if (!visible) return null;
  return (
    <div
      className="flex items-center justify-center gap-1.5 mx-auto mb-6"
      style={{
        width: 'fit-content',
        padding: '4px 12px',
        borderRadius: '9999px',
        backgroundColor: 'rgba(217, 119, 6, 0.10)',
        border: '1px solid rgba(217, 119, 6, 0.25)',
        color: 'rgb(146, 64, 14)',
        fontSize: '11px',
        letterSpacing: '0.02em',
        fontWeight: 500,
      }}
      role="status"
      data-testid="rsvp-preview-mode-notice"
    >
      <Eye className="w-3 h-3" aria-hidden="true" />
      <span>Preview mode · RSVPs won't be saved</span>
    </div>
  );
}
